<template>
<div>
    <b-row>

        <b-col md="6">
            <CCard>
                <CCardHeader color="dark" text-color="white">
                    <i class="fas fa-chart-bar fa-md"></i> <span class="h5"> Estadísticas</span>
                </CCardHeader>
                <CCardBody>
                    <span class="h6 text-muted">ESTADÍSTICAS DEL SISTEMA PARA LAS VENTAS
                    </span>
                    <hr>
                    <b-row class="justify-content-center text-center">
                        <b-col cols="12" class=" my-2 icon-custom">
                            <i style="inline-size: auto" class="fas fa-money-bill-alt fa-3x ico"> </i>
                            <br>
                            <span class="lg-numero">{{listaVentas.length}}</span>
                            <br>
                            <span class="text-muted">Ventas</span>
                        </b-col>
                    </b-row>
                </CCardBody>
            </CCard>
        </b-col>
        <b-col md="6">
            <CCard>
                <CCardHeader color="dark" text-color="white">
                    <i class="fas fa-cog"></i><span class="h5"> Gestión de ventas </span>
                </CCardHeader>
                <CCardBody>
                    <b-row class="text-center justify-content-center">
                        <b-col md="6" class="my-2 ">
                            <b-button block size="md" variant="custom" :to="{name: 'Gestión de venta master'}">
                                <i class="fas fa-plus-circle fa-3x pb-1" style="inline-size: auto"></i>
                                <br>Nueva venta
                            </b-button>
                        </b-col>
                    </b-row>
                </CCardBody>
            </CCard>
        </b-col>

        <b-col md="12">
            <CCard>
                <CCardHeader color="dark" text-color="white">
                    <i class="fas fa-list fa-md"></i> <span class="h5"> Ventas registradas</span>
                </CCardHeader>

                <CCardBody>
                    <div>
                        <b-row>
                            <b-col lg="2">
                                <b-form-group label="Registros por página" class="text-muted">
                                    <b-form-select size="xl" v-model="porPagina" :options="paginaOpciones"></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col lg="7">
                            </b-col>
                            <b-col lg="3">
                                <b-form-group label="Busqueda:" class="text-muted">
                                    <b-input-group size="xl">
                                        <b-input-group-prepend is-text>
                                            <i class="fas fa-search  my-0 mx-0"></i>
                                        </b-input-group-prepend>
                                        <b-form-input type="search" v-model="filter" id="filterInput" placeholder="Buscar..."></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col md="12">
                                <b-table :items="listaVentas" :fields="campoVentas" :current-page="currentPage" :per-page="porPagina" :filter="filter" :filter-included-fields="filterOn" bordered hover show-empty mediun responsive outlined @filtered="onFiltered" empty-text="Aún no hay datos en esta sección." empty-filtered-text="No hay datos que coincidan con tu busqueda.">
                                    <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                                    <template #cell(total)="param">
                                        <span>S/. {{param.item.total}} </span>
                                    </template>
                                    <template v-slot:cell(cliente)="data">
                                        {{data.value | truncate(35)}}
                                    </template>
                                    <template #cell(fechaFinContrato)="param">
                                        <span class="mr-2">{{param.item.fechaFinContrato}}</span>
                                        <span class="h5" v-if="validarFecha(param)">
                                            <b-badge variant="danger">!</b-badge>
                                        </span>
                                    </template>
                                    <template #cell(acciones)="param">
                                        <b-button class="mr-1 mb-1" size="sm" variant="blue" @click="param.toggleDetails" v-c-tooltip="'Servicios'">
                                            <i :class="`fas fa-eye${param.detailsShowing ? '-slash' : ''} my-0 mx-0`"></i>
                                        </b-button>
                                        <b-button @click="verDetalleVenta(param)" class="mr-1 mb-1" size="sm" variant="dark" v-c-tooltip="'Ver detalles'">
                                            <i class="fas fa-search my-0 mx-0"></i>
                                        </b-button>
                                        <b-button @click="eliminarVenta(param)" class="mr-1 mb-1" size="sm" variant="danger" v-c-tooltip="'Eliminar'">
                                            <i class="fas fa-trash-alt my-0 mx-0"></i>
                                        </b-button>
                                    </template>
                                    <template #row-details="row">
                                        <b-row>
                                            <b-col md="3">
                                                <span class="h6"> Servicios contratados: </span>
                                            </b-col>
                                            <b-col md="9">
                                                {{row.item.servicio}}
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="3">
                                                <span class="h6"> Incluye colaborador: </span>
                                            </b-col>
                                            <b-col md="9">
                                                <span v-if="row.item.conColaborador=='2'">SI</span>
                                                <span v-else-if="row.item.conColaborador=='1'">NO</span>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </div>
                </CCardBody>
                <CCardFooter>
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="porPagina" align="right" size="sm" class="my-0"></b-pagination>
                </CCardFooter>
            </CCard>
        </b-col>
    </b-row>
</div>
</template>

<script>
import axios from "axios";
import CONSTANTES from "@/Constantes.js";

export default {
    data() {
        return {
            totalRows: 0,
            currentPage: 1,
            filter: null,
            filterOn: [],
            porPagina: 10,
            paginaOpciones: [10, 25, 50, 100, {
                value: 9999999,
                text: "Mostrar todos"
            }],
            campoVentas: [{
                    key: "index",
                    label: "N°",
                    class: "text-center",
                },
                {
                    key: "cliente",
                    label: "Cliente",
                    class: "text-center",
                },
                {
                    key: "fechaVenta",
                    label: "Inicio contrato",
                    class: "text-center",
                },
                {
                    key: "fechaFinContrato",
                    label: "Finalización",
                    class: "text-center",
                },
                {
                    key: "total",
                    label: "Importe",
                    class: "text-center",
                },
                {
                    key: "acciones",
                    label: "",
                    class: "text-center"
                }
            ],
            listaVentas: [],
        }
    },
    methods: {
        getValidationState({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        validarFecha(param) {
            return moment(param.item.fechaFinContrato).isSameOrBefore(moment().format('YYYY-MM-DD'))
        },

        listarVentas() {
            let me = this;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${localStorage.token}`;
            axios
                .get(CONSTANTES.URL_RUTA_SERVICIOS + "master/listar-ventas", {
                    params: {
                        activo: 2
                    }
                })
                .then(function (response) {
                    me.listaVentas = response.data;
                    me.totalRows = me.listaVentas.length;
                    //me.obtenerDatosEstadisticos();
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!')
                });
        },
        verDetalleVenta(param) {
            let me = this;
            me.$router.push({
                name: 'Gestión de venta master',
                params: {
                    id: param.item.idVenta,
                }
            });
        },
        eliminarVenta(param) {
            let me = this
            me.$swal.fire({
                title: '¿Estas seguro de eliminar la venta?',
                text: "¡No podrás revertir esto!",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .post(CONSTANTES.URL_RUTA_SERVICIOS + "master/eliminar-venta", {
                            idVenta: param.item.idVenta
                        }, {
                            headers: {
                                Authorization: `Bearer ${localStorage.token}`,
                            }
                        })
                        .then(function (response) {
                            let color = response.data.resultado == 1 ? "success" : "error";
                            me.swat(color, response.data.mensaje)
                            me.listarVentas();
                        })
                        .catch(function (error) {
                            me.swat('error', 'Algo salió mal!')
                        });
                }
            })
        },
        swat(icon, title) {
            this.$swal.mixin({
                toast: true,
                showConfirmButton: false,
                position: 'bottom-right',
                timer: 3500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            }).fire({
                icon: icon,
                title: title
            });
        },
    },

    mounted() {
        let me = this;
        me.listarVentas();
    }

}
</script>
